
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Workorder,
  WorkordersApi,
  PerformoSettings,
  ValidationProblemDetails
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    ordersApi: 'ordersApi',
    settings: 'settings'
  })
})
export default class OpenSubStatusComponent extends Vue {
  private ordersApi!: WorkordersApi;
  private settings!: PerformoSettings;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private isLoading = false;

  private get buttonText() {
    if (
      this.order.orderStatus &&
      this.settings.openSubStatuses &&
      this.settings.openSubStatuses.includes(this.order.orderStatus)
    ) {
      return this.order.orderStatus;
    } else {
      return 'Open';
    }
  }

  private get buttonActive() {
    if (this.order.orderStatus === 'Open') return true;
    if (this.order.orderStatus && this.settings.openSubStatuses) {
      return this.settings.openSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private get orderStatusIsCompleteSubStatus() {
    if (this.order.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private async onOpenClickHandler() {
    if (!this.order.workorderId) return;

    this.isLoading = true;
    try {
      await this.ordersApi.openOrder({ workorderId: this.order.workorderId });
      this.$emit('set-open');
    } catch (error) {
      this.errorHandler(error as ValidationProblemDetails);
    }
    this.isLoading = false;
  }

  private async onSubStatusClickHandler(requestedStatus: string) {
    if (!this.order.workorderId) return;

    this.isLoading = true;
    try {
      await this.ordersApi.setSubStatus({
        workorderSetSubStatusCommand: {
          requestedStatus: requestedStatus,
          workorderId: this.order.workorderId
        }
      });
      this.$emit('set-sub-status');
    } catch (error) {
      this.errorHandler(error as ValidationProblemDetails);
    }
    this.isLoading = false;
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    this.$emit('error', error);
  }
}
